import React, { useEffect } from 'react';
import { useStore } from 'react-redux';
import { routerHelperActions, selectRouterHelper } from '@wfp-common/store/routerHelperSlice';
import { Routes, useNavigate } from 'react-router-dom';
import { dispatch, useStoreSelector } from '@wfp-root-app/store/store';

import scheduleManagerTokenExpirationChecks from '../utils/sessionExpiration/scheduleManagerTokenExpirationChecks';
import AppRoutes from '../Routes';

function scheduleTokenExpirationChecks() {
    if (document.visibilityState === 'visible') {
        dispatch(scheduleManagerTokenExpirationChecks());
    }
}

document.addEventListener('visibilitychange', scheduleTokenExpirationChecks);
scheduleTokenExpirationChecks();

const App = () => {
    const store = useStore();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const routerHelper = useStoreSelector(selectRouterHelper);
    const navigate = useNavigate();

    useEffect(() => {
        if (!routerHelper.redirectUrl) return;

        const reg = /^\/\S*$/g.test(routerHelper.redirectUrl);
        navigate(reg ? routerHelper.redirectUrl : `/${routerHelper.redirectUrl}`, { ...routerHelper.navigateState });
        store.dispatch(routerHelperActions.clearRedirect());
    }, [routerHelper.redirectUrl]);

    return <AppRoutes />;
};

export default App;
